import {classNames, Fragment, observer, React, useAsObservableSource, useEffect} from '@api'
import {Icon, InputGroup, Switch} from '@blueprintjs/core'
import {useChangeLogFlexLayoutTabStore, useVipLocalStore} from '@modules'
import {ChangeLogTitleBarStore, ChangeLogTitleBarStoreContext, ChangeLogFilterChips, ChangeLogToggleFiltersDropdownIcon} from './'
import * as css from './ChangeLogToolbar.css'
import {ChangeLogFilterIcon, ChangeLogSortIcon, icons} from '@stores/ui'
import {PrimaryIconButton, SearchField2} from 'centric-ui-components'
import {Search, Sync} from '@material-ui/icons'

interface MyProps {
  className?: string
}

export const ChangeLogToolbar = observer<MyProps>(function ChangeLogToolbar({className, ...props}) {
  const rootStore = useChangeLogFlexLayoutTabStore(),
    obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogTitleBarStore(stores, rootStore, obsProps)),
    {
      newLook, toggleNewLook, onClickClearAllFilters, searchText, onSearch, isGridView, toggleGridView,
      trackCurrentWorkspace, toggleTrackCurrentWorkspace, flexLayout: {activeOrLastCatalogRoot},
      catalog: {settings: {changelog: settings}}, shouldApplyFilters, toggleApplyFilters, filteredFields
    } = rootStore

  useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogTitleBarStoreContext.Provider value={store}>
      <Fragment>
        <div className={classNames(css.root, className)}>
          <div className={css.left}>
            <InputGroup className={css.search} leftElement={<Search/>} type='search' onChange={onSearch} value={searchText ?? ''} placeholder='Search Change Log...'/>
            <ChangeLogToggleFiltersDropdownIcon/>

            <div className={css.chips}>
              {/*<ChangeLogTitleBarItem title={filterLabel} applied={!!filterCount} chipIcon={<ChangeLogFilterIcon/>} onClear={onClickClearAllFilters} feature={'filter'}/>*/}
              {/*<ChangeLogTitleBarItem title={sortLabel} applied={!!sortCount} chipIcon={<ChangeLogSortIcon/>} onClickMenuItem={onClickSortMenuItem} feature={'sort'}/>*/}
            </div>
          </div>
          <div className={css.right}>
            <PrimaryIconButton
              icon={<Sync/>}
              data-type={'reload'}
              tooltip={'Reload'}
              onClick={rootStore.refetch}
              className={css.icon}
            />
            <PrimaryIconButton
              icon={icons.workspace}
              active={trackCurrentWorkspace}
              disabled={activeOrLastCatalogRoot == null}
              onClick={toggleTrackCurrentWorkspace}
              tooltipPosition='bottom'
              tooltip='Track Current Workspace'
              tooltipStyle='mui'
            />

            <PrimaryIconButton
              icon='panel-table'
              active={isGridView}
              onClick={toggleGridView}
              tooltipPosition='bottom'
              tooltip='Grid View'
              tooltipStyle='mui'
            />

            <PrimaryIconButton
              icon={icons.openInNew}
              className={css.icon}
              tooltip={'Export Data'}
              tooltipStyle='mui'
              onClick={rootStore.exportExcel}
            />

            {DEBUG && <PrimaryIconButton
				icon={icons.dev}
				active={newLook}
				onClick={toggleNewLook}
				tooltipPosition='bottom'
				tooltip='New Look'
				tooltipStyle='mui'
			/>}

          </div>
        </div>
        {!_.isEmpty(settings.filters) && <div className={css.secondLevelToolbar}>
          <div className={css.left}>
            <ChangeLogFilterChips/>
          </div>
          <div className={css.right}>
            <Switch className={css.toggle}
                    disabled={filteredFields.size == 0}
                    checked={shouldApplyFilters}
                    onChange={() => setTimeout(() => toggleApplyFilters(), 100)}
                    label='Apply Filters'/>
          </div>
        </div>}
      </Fragment>
    </ChangeLogTitleBarStoreContext.Provider>)
})




// WEBPACK FOOTER //
// ./src/modules/changelog/toolbar/ChangeLogToolbar.tsx